// react
import { useContext } from 'react';

// types
import { Document, Transaction } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextUserProjectPermissions } from '../../../pages/Project/Project.context';

// headers
import { getDocumentsHeaders } from './TableBasicDocs.headers';

// dialogs
import { DialogEditDocument } from '../../../dialogs/DialogEditDocument/DialogEditDocument';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// props
export interface TableBasicDocsProps extends Omit<TableProps, 'headers'> {
	data: Document[];
	hasBtnMenu?: boolean;
	refetchDocuments?: () => void;
	transaction?: Transaction;
}

export const TableBasicDocs = ({
	data = [],
	hasBtnMenu = true,
	refetchDocuments,
	transaction,
	...props
}: TableBasicDocsProps) => {
	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// params
	const paramDialog = searchParams.get('dialog');
	const paramDialogDocument = searchParams.get('dialogDocument');

	// context
	const { userProjectPermissions } = useContext(ContextUserProjectPermissions);

	// handlers
	const handleCloseDialog = () => {
		searchParams.delete('dialog');
		searchParams.delete('dialogDocument');
		setSearchParams(searchParams);
	};

	// vars
	const headers: TableHeader[] = getDocumentsHeaders({
		hasBtnMenu,
		searchParams,
		setSearchParams,
		t,
		userProjectPermissions,
	});

	return (
		<>
			<Table {...props} data={data} headers={headers} />
			<DialogEditDocument
				isOpen={paramDialog === 'editDocument' && Boolean(paramDialogDocument)}
				onClose={handleCloseDialog}
				onSuccess={() => {
					if (refetchDocuments) {
						refetchDocuments();
					}
				}}
			/>
		</>
	);
};
